import { createSlice } from "@reduxjs/toolkit";
import { updateTermsAndConditionsStatusAPI } from "../../services/updateTermsAndConditionsStatus";

const initialState = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
  updatingId: null,
  statusCode: undefined,
};

const updateTermsAndConditionsStatusSlice = createSlice({
  name: "updateTermsAndConditionsStatus",
  initialState,
  reducers: {
    updateTermsAndConditionsStatusInfo(state, action) {
      state.isLoading = true;
      state.updatingId = action?.payload?.termsConditionId ?? null;
      state.error = "";
      state.message = "";
      state.statusCode = undefined;
    },
    updateTermsAndConditionsStatusInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.error = "";
      state.message = "Status updated successfully";
      state.updatingId = null;
      state.statusCode = undefined;
    },
    updateTermsAndConditionsStatusInfoFailure(state, action) {
      const payload =
        action.payload && typeof action.payload === "object"
          ? action.payload
          : { message: action.payload };
      state.isLoading = false;
      state.message = "";
      state.error = payload.message ?? "";
      state.statusCode = payload.statusCode;
      state.data = null;
      state.updatingId = null;
    },
    updateTermsAndConditionsStatusInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
      state.updatingId = null;
      state.statusCode = undefined;
    },
  },
});

export const updateTermsAndConditionsStatusHandler =
  (payload, options = {}) =>
  async (dispatch) => {
    const requestOptions = { skipForbiddenRedirect: true, ...options };

    try {
      dispatch(
        updateTermsAndConditionsStatusAction.updateTermsAndConditionsStatusInfo(
          payload,
        ),
      );
      const response = await updateTermsAndConditionsStatusAPI(
        payload,
        requestOptions,
      );
      dispatch(
        updateTermsAndConditionsStatusAction.updateTermsAndConditionsStatusInfoSuccess(
          response,
        ),
      );
    } catch (e) {
      const failurePayload =
        e && typeof e === "object" && "message" in e
          ? e
          : { message: e || "Something went wrong." };
      dispatch(
        updateTermsAndConditionsStatusAction.updateTermsAndConditionsStatusInfoFailure(
          failurePayload,
        ),
      );
    }
  };

export default updateTermsAndConditionsStatusSlice.reducer;
export const updateTermsAndConditionsStatusAction =
  updateTermsAndConditionsStatusSlice.actions;
